import request from '@/utils/request'
export function stationList(query) {
  return request({
    url: '/first/sites/?type=a',
    method: 'get',
    params: query
  })
}
export function stationAdd(data) {
  return request({
    url: '/first/sites/',
    method: 'post',
    data
  })
}
export function stationEdit(data) {
  const { body, params } = data;
  return request({
    url: '/first/sites/?pk=' + params.pk,
    method: 'put',
    data: body,
  })
}
export function stationDelete(data) {
  return request({
    url: '/first/sites/?pk=' + data.pk,
    method: 'delete'
  })
}
export function transcodeModeList(query) {
  return request({
    url: '/first/trans_cmd/?type=a',
    method: 'get',
    params: query
  })
}
export function transcodeModeAdd(data) {
  return request({
    url: '/first/trans_cmd/',
    method: 'post',
    data
  })
}
export function transcodeModeEdit(data) {
  const { body, params } = data;
  return request({
    url: '/first/trans_cmd/?pk=' + params.pk + '&uid=' + params.uid + '&sid=' + params.sid,
    method: 'put',
    data: body,
  })
}
export function transcodeModeDelete(data) {
  return request({
    url: '/first/trans_cmd/?pk=' + data.pk,
    method: 'delete'
  })
}
